// Cognito identifiers for the direct AWS SDK calls (AccountSettings) and for
// the hosted-UI logout redirect.
//
// Derived from the same VITE_COGNITO_* variables oidc-config.ts reads, rather
// than repeated as literals. The previous version hardcoded production's pool
// and client id, so a build for any other environment authenticated its OIDC
// flow against the new pool while these two call sites still pointed at
// production — and silently, because a stale pool id produces a "not signed in"
// rather than an error.

// The authority is `https://cognito-idp.<region>.amazonaws.com/<poolId>`.
function poolIdFromAuthority(authority: string): string {
  const poolId = authority.split('/').pop() ?? '';
  if (!/^[a-z]{2}-[a-z]+-\d_[A-Za-z0-9]+$/.test(poolId)) {
    throw new Error(
      `VITE_COGNITO_AUTHORITY does not end in a user pool id: "${authority}"`,
    );
  }
  return poolId;
}

export const userPoolId = poolIdFromAuthority(import.meta.env.VITE_COGNITO_AUTHORITY);
export const clientId = import.meta.env.VITE_COGNITO_CLIENT_ID;
export const cognitoDomain = import.meta.env.VITE_COGNITO_DOMAIN;
